// 正则
import regular from '../../static/js/validate/regular'

/**
 * s-input 格式及为空/格式验证
 * @author 王硕
 * @param item
 * @returns {*}
 */
export default (item) => {
  item.tips = '';
  if(item.value !== ''){
    // 格式验证
    if(item.regular && !regular[item.regular].test(item.value)){
      item.tips = 'error'
    }

  }else if(item.must){
    // 为空验证
    item.tips = 'empty'
  }

  return item;
}




// WEBPACK FOOTER //
// ./src/components/s-input/verifySItem.js